import { CloseSvg } from "@/components/Icon/Icon";
import { RootState } from "@/store/store";
import { Box, Divider, IconButton, Typography, useTheme } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

interface InboxActionBarProps {
  handleCloseActionBar: () => void;
  selector: (state: RootState) => number;
  children?: React.ReactNode;
}

const ActionBarInfo = ({ selector }: { selector: (state: RootState) => number }) => {
  const { t } = useTranslation("common");
  const numChecked = useSelector(selector);

  return <Typography style={{ minWidth: "140px" }}>{t("label.itemSelected", { count: numChecked })}</Typography>;
};

export const ActionBar: FC<InboxActionBarProps> = ({ handleCloseActionBar, selector, children }) => {
  const theme = useTheme();

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        width: "100%",
        height: "52px",
        padding: "6px",
        borderRadius: "26px",
        gap: "8px",
        justifyContent: "flex-start",
        alignItems: "center",
        alignContent: "center",
        boxSizing: "border-box",
        backgroundColor: theme.palette.background.paper,
        overflowX: "auto",
        overflowY: "hidden"
      }}
    >
      <IconButton
        onClick={(e: React.SyntheticEvent) => {
          e.stopPropagation();
          handleCloseActionBar();
        }}
      >
        <CloseSvg color="inherit" />
      </IconButton>
      <ActionBarInfo selector={selector} />
      <Divider orientation="vertical" flexItem />
      {children}
    </Box>
  );
};
